/**
 * USP (Unique Selling Points) bar carousel
 * Creates an auto-playing slider for promotional messages and selling points
 * Includes theme editor integration and responsive breakpoint handling
 */

(async () => {

  const { default: Swiper, Autoplay } = await import("swiper");

  Swiper.use([
    Autoplay
  ]);

  class UspBar extends HTMLElement {
    constructor() {
      super();

      document.body.classList.add('usp-bar-visible');
      this.swiperElement = this.querySelector('[data-swiper-usp-bar]');
      this.swiperOptions = {
        autoplay: {
          disableOnInteraction: false
        },
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
          }
        }
      }
      this.init();
    }
    init() {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

      if(Shopify.designMode && this.swiperInstance) {

        window.addEventListener('shopify:section:load', () => {
          this.swiperInstance.update();
        });

        window.addEventListener('shopify:block:select', (event) => {
          this.swiperInstance.update();
          this.handleThemeEditorEvents(event);
        });
      }
    }

    /**
     * Handles the theme editor block change/edit event
     * @param {Object} event
     */
    handleThemeEditorEvents(event) {
      // Slide to slide based on the data attribute from the target and add 1 to get the slide index
      this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
    }

  }

  window.UspBar = UspBar;

  customElements.define('usp-bar', UspBar);

})();
